import { BCMSStateManagerCRUD, BCMSValidate, ModalClose, StateManager, useStateManager, useWorkflow } from "@bcm-dev/bcms-vite";
import { ContactInfo } from "model";

import { FormContainer, FormRowView, LayoutContainer, LeftColumnContainer, RightColumnContainer } from 'components/shared';
import { FormButtonRow } from 'components/shared/containers/FormContainer';
import UINotifiButton from 'components/shared/notifi/UINotifiButton';
import { UITextInput } from 'components/ui';
import { SVGAsset } from 'res';
import ProgressionBarWidget, { ProgressionStep } from "../ProgressionBarWidget";

import "./styles.css";

export default function AddSmsContactView(props) {
    const data = { ...getDefaultViewData(), ...props.data ?? {} };
    const ui = { ...getDefaultViewUI(), ...props.ui ?? {} };

    const { nextStep, state: workflow } = useWorkflow() ?? {};

    const controller = (state, setState) => ({
        data: state.data,
        ui: state.ui,

        onSubmit: evt => {
            const info = state.data.info;
            info.value = info.value.replaceAll(/[-() ]/g, "");

            // Validation for the user entered phone number.
            if((BCMSValidate.isNumber(info.value) && info.value.length === 10)) {
                info.value = `(${ info.value.slice(0, 3) }) ${ info.value.slice(3, 6) }-${ info.value.slice(6) }`;
            } else {
                info.value = "(231) 256-7890";
            }

            info.type = "phone";

            const workflowState = BCMSStateManagerCRUD.init(workflow)
                .update([ "data", "info" ], info)
                .update([ "data", "unconfirmedContacts" ], [ ...workflow.data.unconfirmedContacts, info ])
                .submit();
            
            nextStep(workflowState);
        },

        onChange: value => {
            BCMSStateManagerCRUD.init(state)
                .update([ "data", "info", "value" ], value)
                .submit(setState);
        }
    });

    return (
        <StateManager state={ { data, ui } } controller={ controller }>
            <AddSmsContactContent />
        </StateManager>
    );
}

export const getDefaultViewData = () => ({
    info: ContactInfo.init({}),
    unconfirmedContacts: []
});
export const getDefaultViewUI = () => ({});

function AddSmsContactContent(props) {
    const { data, onChange, onSubmit } = useStateManager();
    const btnIsDisabled = data.info.value.length > 0 ? "clickable" : "disabled";

    return (
        <LayoutContainer>
            <LeftColumnContainer>
                <div className="flex-container justify-right close-container mobile-container">
                    <ModalClose id="AddContactMethodModal" className="clickable text-right">
                        <SVGAsset id="CloseX" />
                    </ModalClose>
                </div>
                {/* The progression bar ui is updated here as the user navigates through the workflow. */}
                
                <ProgressionBarWidget>
                    <ProgressionStep activeClass="active" />
                    <ProgressionStep />
                </ProgressionBarWidget>

                <div className="add-sms-contact-view">
                    <div className="flex-container flex-vertical all-center header-container text-center">
                        <h1>Add a SMS contact</h1>
                        <h3>To get started, specify where you want to send Notifications to.</h3>
                    </div>
                    <FormContainer>
                        <FormRowView className="flex-horizontal align-center input-container phone">
                            <SVGAsset id="SquareMessageBubbleIcon" className="square-message-bubble-icon" />
                            <UITextInput placeholder="Phone Number" value={ data.info.value }
                            onChange={ onChange } dataPoint="PhoneNumberEntry"/>
                        </FormRowView>
                        <FormButtonRow className="justify-right">
                            <UINotifiButton text="Next" onClick={ onSubmit } className={ btnIsDisabled } dataPoint="NextButton"/>
                        </FormButtonRow>
                    </FormContainer>
                </div>
            </LeftColumnContainer>

            <RightColumnContainer>
                <div className="flex-container justify-right close-container">
                    <ModalClose id="AddContactMethodModal" className="clickable">
                        <SVGAsset id="CloseX" />
                    </ModalClose>
                </div>
                <h2>What are notifications?</h2>
                <p>Notifications are a great way to stay on top of important things happening with your profile and accounts.</p>
                <p>You can turn on the notifications that matter most to you and personalize them to meet your needs.</p>
                <h2>Tip</h2>
                <div className="flex-container">
                    <div className="set-width">
                        <SVGAsset id="InfoIcon" className="icon info-icon" />
                    </div>
                    <div className="flex-width">
                        <p>You can add or change your contact info later in notifications Settings.</p>
                    </div>
                </div>
            </RightColumnContainer>
        </LayoutContainer>
    )
}